import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { uniqueId } from 'lodash'
import { Dispatch } from 'redux'
import { postTransactionApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { SubmissionPayload } from '../containers/TradeForm/Types'
import { TEMPORARILY_UNAVAILABLE, TRADE_CREATION_FAILURE, TRADE_SUBMITTED_MESSAGE } from './constants'

export const POST_TRANSACTION = uniqueId('POST_TRANSACTION')
export const POST_TRANSACTION_SUCCESS = uniqueId('POST_TRANSACTION_SUCCESS')
export const POST_TRANSACTION_SUCCESS_ACKNOWLEDGE = uniqueId('POST_TRANSACTION_SUCCESS_ACKNOWLEDGE')
export const POST_TRANSACTION_FAILURE = uniqueId('POST_TRANSACTION_FAILURE')

export const postTransaction = (dispatch: Dispatch, payload: SubmissionPayload, successCallback: () => void) => {
  dispatch({ type: POST_TRANSACTION, payload })
  postTransactionApi(payload)
    .then((response: AxiosResponse) => {
      const {
        data: [{ accountNumber, correspondent, externalId, id, status, timestamp }],
      } = response
      dispatch({
        type: POST_TRANSACTION_SUCCESS,
        tradeSubmittedMessage: TRADE_SUBMITTED_MESSAGE,
        tradeSubmissionDetails: {
          accountNumber,
          correspondent,
          externalId,
          id,
          status,
          timestamp,
        },
      })
      successCallback()
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus && httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : TRADE_CREATION_FAILURE
      dispatch({ type: POST_TRANSACTION_FAILURE, tradeSubmissionFailedMessage: errorMessage })
    })
}

export const acknowledgeTradeSubmission = (dispatch: Dispatch) =>
  dispatch({ type: POST_TRANSACTION_SUCCESS_ACKNOWLEDGE })
